// @ts-nocheck
import { CHANGE_REQUEST_REQUIRED_LIST_ERROR, CHANGE_REQUEST_REQUIRED_LIST_LOADING, CHANGE_REQUEST_REQUIRED_LIST_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const ChangeRequestRequiredListReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_REQUEST_REQUIRED_LIST_LOADING:
            return Object.assign({}, state, { loading: true })
        case CHANGE_REQUEST_REQUIRED_LIST_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case CHANGE_REQUEST_REQUIRED_LIST_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

